import { Skeleton } from 'antd';
import Error from 'next/error';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import request from '@/utils/axios';

async function getProfileDetails(id) {
  try {
    const response = await request({
      url: `/profile/details?personId=${id}`,
      triggerLoad: false,
    });
    return response.data;
  } catch (err) {
    console.warn(err);
    return {
      error: 'There was an error processing the request',
    };
  }
}

function FullProfileProvider({ children, personId }) {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(async () => {
    const user = await getProfileDetails(personId);
    setUserInfo(user);
  }, []);

  if (!userInfo) {
    return <Skeleton paragraph={{ rows: 12 }} active />;
  }

  if (userInfo.Success && userInfo.Success === 'false') {
    return <Error />;
  }

  return React.Children.map(children, child => {
    return React.cloneElement(child, {
      user: userInfo,
    });
  });
}

const mapStateToProps = state => {
  const {
    auth: {
      userinfo: { PersonID },
    },
  } = state;

  return {
    personId: PersonID,
  };
};

export default connect(
  mapStateToProps,
  {
    getProfileDetails,
  }
)(FullProfileProvider);
